import React from 'react'
import Panel from '../components/Panel';

export default class ActuPage extends React.Component {
    render() {
        return <Panel title="To Do">
            Non disponible pour le moment
        </Panel>
    }
}